<template>
<div>
    <div class="container">
        <div class="space-100"></div>
        <div class="row">
            <div class="col-sm-4">
                <div>
                    <h2>Buscar</h2>
                </div>
                <div>
                    <form action="">
                        <input class="checkbox-style" type="checkbox"> Puntos fijos<br>
                        <input class="checkbox-style" type="checkbox"> Porcenyaje fijo<br>
                        <input class="checkbox-style" type="checkbox"> Porcentaje adicional<br>
                        <input class="checkbox-style" type="checkbox"> Multiplica Porcentaje<br>
                        <input class="checkbox-style" type="checkbox"> Promociones<br>
                        <input class="checkbox-style" type="checkbox"> Genéricos<br>
                        <input class="checkbox-style" type="checkbox"> Vigencia ilimitada<br>
                        <input class="checkbox-style" type="checkbox"> Vencen este mes<br>
                        <input class="checkbox-style" type="checkbox"> Vencen prócimo mes<br>
                        <input type="text" class="inputs" value="Cupón puntos fijos">
                    </form>
                </div>
                <div class="text-center">
                    <button class="redimir-button">Redimir</button>
                </div>
            </div>
            <div class="col-sm-8">
                <div class="row">
                    <div class="col-sm-9">
                        <h2><strong>Cupones </strong></h2>
                    </div>
                    <div class="col-sm-3 text-right back-button">
                        <router-link class="nav-link"  to="/PerfilUsuario">
                            <a class="text-color" href="#"><img src="../assets/assets_loyalty/flecha-izquierda.png"> Regresar</a>
                        </router-link>
                    </div>
                </div>
                <!-- <div class="row">
                    <div>
                        <label>Ordenar por: </label>
                        <select class="select-style" name="" id="">
                            <option value="">Nombre A -Z</option>
                        </select>
                    </div>
                </div> -->
                <div>
                    <div class="row justify-content-center">
                        <div class="col-sm-5 borders-defult">
                            <img class="cupon-img" src="../assets/assets_loyalty/assets-19.png" alt="">
                            <p class="margin-defult">Cupon de puntos fijos 01321654</p>
                            <p class="margin-defult">este cupon vale por <strong>30pts</strong></p>
                            <p class="margin-defult">Código <strong>$xqcxm0</strong></p>
                            <p class="validity-date">Vigente hasta el dd/mm/yyyy</p>
                        </div>
                        <div class="col-sm-5 borders-defult">
                            <img class="cupon-img" src="../assets/assets_loyalty/assets-19.png" alt="">
                            <p class="margin-defult">Cupon de puntos fijos 01321654</p>
                            <p class="margin-defult">este cupon vale por <strong>30pts</strong></p>
                            <p class="margin-defult">Código <strong>$xqcxm0</strong></p>
                            <p class="validity-date">Vigente hasta el dd/mm/yyyy</p>
                        </div>
                        <div class="col-sm-5 borders-defult">
                            <img class="cupon-img" src="../assets/assets_loyalty/assets-19.png" alt="">
                            <p class="margin-defult">Cupon de puntos fijos 01321654</p>
                            <p class="margin-defult">este cupon vale por <strong>30pts</strong></p>
                            <p class="margin-defult">Código <strong>$xqcxm0</strong></p>
                            <p class="validity-date">Vigente hasta el dd/mm/yyyy</p>
                        </div>
                        <div class="col-sm-5 borders-defult">
                            <img class="cupon-img" src="../assets/assets_loyalty/assets-19.png" alt="">
                            <p class="margin-defult">Cupon de puntos fijos 01321654</p>
                            <p class="margin-defult">este cupon vale por <strong>30pts</strong></p>
                            <p class="margin-defult">Código <strong>$xqcxm0</strong></p>
                            <p class="validity-date">Vigente hasta el dd/mm/yyyy</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { Card, FormGroupInput, Button } from '@/components';

export default {
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data(){
    return {
    }
  }
}
</script>
<style>
.margin-defult{
    margin: 0px;
}
.redimir-button{
    width: 50%;
    height: 40px;
    color: white;
    margin: 10px;
    font-size: 17px;
    background-color: #00bbff; 
    border-radius: 21px 21px 21px 21px;
    -moz-border-radius: 21px 21px 21px 21px;
    -webkit-border-radius: 21px 21px 21px 21px;
    border: 0px solid #ffffff;
}
.text-color-blue{
    color: #00bbff;
}
.borders-defult{
    width: 23%;
    padding: 5px;
    margin: 8px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #000000;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
    -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
}
.cupon-img{
    padding: 30px 5px 30px 5px;
}
.validity-date{
    margin: 0px;
    font-size: 10px;
    padding-left: 140px;
}
.inputs{
  width: 90%;
  padding: 5px;
  background-color: white;
  margin: 10px;
  border: 1px;
  border-bottom: 2px solid #ECECEC;
}
.checkbox-style{
    margin: 10px;
}
.select-style{
    margin: 0px 0px 0px 10px;
    width: 150px;
    height: 30px;
    font-size: 14px;
    border-radius: 21px 21px 21px 21px;
    -moz-border-radius: 21px 21px 21px 21px;
    -webkit-border-radius: 21px 21px 21px 21px;
    border: 2px solid #ECECEC;
}
</style>
